import { render, staticRenderFns } from "./SelectChannelGroupModal.vue?vue&type=template&id=672af422&"
import script from "./SelectChannelGroupModal.vue?vue&type=script&lang=ts&"
export * from "./SelectChannelGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports